import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Todo from "./Todo";
import { Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useState, useContext, useEffect } from "react";
import { TodosContext } from "../contexts/myContext";
//other package uuid
import { v4 as uuidv4 } from "uuid";

export default function TodoList() {
  const { todos, SetTodos } = useContext(TodosContext);
  const [titleInput, SetTitleInput] = useState();
  const [displayTypeTodos,setDisplayTypeTodos]=useState("all")
  useEffect(() => {
    const updateTodos = JSON.parse(localStorage.getItem("todos")) ?? [];
    SetTodos(updateTodos);
  }, []);
  
  
  function handlClick() {
    const myTodo = {
      id: uuidv4(),
      title: titleInput,
      details: "",
      isCompleted: false,
    };
    const updateTodos = [...todos, myTodo];
    SetTodos(updateTodos);
    localStorage.setItem("todos", JSON.stringify(updateTodos));
    SetTitleInput("");
  }
  function handlChangeDisplay(e){
    setDisplayTypeTodos(e.target.value);
  }

  const Completed=todos.filter((event)=>{
    return event.isCompleted;
  })
  const nonCompleted=todos.filter((event)=>{
    return !event.isCompleted;
  })

  let TypeTodos=todos;

  if(displayTypeTodos=="completed"){
    TypeTodos=Completed;
  }else if(displayTypeTodos=="non-Completed"){
    TypeTodos=nonCompleted;
  }else{
    TypeTodos=todos;
  }

  const myTodo = TypeTodos.map((event) => {
    return <Todo key={event.id} todo={event} />;
  });
  return (
    <Container maxWidth="sm">
      <Card sx={{ minWidth: 275 }} style={{
        maxHeight:"80vh",
        overflow:"scroll",
      }}>
        <CardContent>
          <Typography gutterBottom variant="h1">
            مهامي
            <Divider />
          </Typography>

          {/* toggle Button */}

          <ToggleButtonGroup
            style={{ direction: "ltr" }}
            value={displayTypeTodos}
            exclusive
            onChange={handlChangeDisplay}
            aria-label="text alignment"
          >
            <ToggleButton style={{ fontWeight: "bold" }} value="non-Completed">
              غيرمنجز
            </ToggleButton>
            <ToggleButton style={{ fontWeight: "bold" }} value="completed">
              المنجز
            </ToggleButton>
            <ToggleButton style={{ fontWeight: "bold" }} value="all">
              الكل
            </ToggleButton>
          </ToggleButtonGroup>

          {/* End Toggle Button */}

          {/* Todo component */}
          {myTodo}
          {/* End Todo component */}
          <Grid
            container
            spacing={2}
            style={{ direction: "rtl", marginTop: "15px" }}
          >
            <Grid
              size={8}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-around"}
            >
              <TextField
                id="outlined-basic"
                label="عنوان المهمة"
                variant="outlined"
                style={{ width: "100%" }}
                value={titleInput}
                onChange={(e) => {
                  SetTitleInput(e.target.value);
                }}
              />
            </Grid>
            <Grid
              size={4}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-around"}
            >
              <Button
                onClick={() => {
                  handlClick();
                }}
                variant="contained"
                style={{ width: "100%", height: "100%", fontSize: "18px" }}
                disabled={!titleInput}
              >
                إضافة
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
}
